(function () {
  'use strict';

  if (window.__tmChatLoaderInit) return;
  window.__tmChatLoaderInit = true;

  var CHAT_SRC = 'https://bot.teknoflow.io/widget/teknomuaz-chat.js';
  var SHOP = 'teknomuaz';
  var PUBLIC_KEY =
    'b94da225f883f6125efc70f832699d5ea5af12f2c701805c3498d4e34d282ed0';

  var fallbackTimer = null;
  var interactionEvents = ['scroll', 'click', 'touchstart', 'keydown'];
  var bridgeStarted = false;
  var hostObserver = null;
  var shadowObserver = null;

  var HIDE_BUBBLE_CSS =
    '.tm-btn,.tm-label,.tm-fab,.tm-launcher{' +
    'display:none!important;' +
    'visibility:hidden!important;' +
    'opacity:0!important;' +
    'pointer-events:none!important;' +
    'width:0!important;' +
    'height:0!important;' +
    'overflow:hidden!important;' +
    'clip:rect(0,0,0,0)!important;' +
    'margin:0!important;' +
    'padding:0!important;' +
    'border:none!important;' +
    'box-shadow:none!important' +
    '}';

  function injectChat() {
    if (window.__tmChatLoaded) return;
    window.__tmChatLoaded = true;

    if (!document.body) return;

    if (document.querySelector('script[src="' + CHAT_SRC + '"]')) {
      startChatUiBridge();
      return;
    }

    var script = document.createElement('script');
    script.src = CHAT_SRC;
    script.setAttribute('data-shop', SHOP);
    script.setAttribute('data-public-key', PUBLIC_KEY);
    script.onload = function () {
      startChatUiBridge();
    };
    document.body.appendChild(script);
  }

  function scheduleLoad() {
    if (window.__tmChatScheduled) return;
    window.__tmChatScheduled = true;

    if (fallbackTimer) {
      clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }

    var run = function () {
      injectChat();
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 0);
    }
  }

  function injectChatBubbleHideStyle(shadowRoot) {
    if (!shadowRoot) return;

    var style = shadowRoot.getElementById('tm-theme-hide-bubble');
    if (!style) {
      style = document.createElement('style');
      style.id = 'tm-theme-hide-bubble';
      style.textContent = HIDE_BUBBLE_CSS;
      shadowRoot.insertBefore(style, shadowRoot.firstChild);
    }

    shadowRoot.querySelectorAll('.tm-btn, .tm-label, .tm-fab, .tm-launcher').forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function getChatHost() {
    return document.getElementById('tm-web-chat-host');
  }

  function observeShadow(shadowRoot) {
    if (!shadowRoot || shadowObserver) return;

    shadowObserver = new MutationObserver(function () {
      injectChatBubbleHideStyle(shadowRoot);
    });

    shadowObserver.observe(shadowRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  function disconnectHostObserver() {
    if (!hostObserver) return;
    hostObserver.disconnect();
    hostObserver = null;
  }

  function hideWidgetBubble() {
    var host = getChatHost();
    if (!host || !host.shadowRoot) return false;

    injectChatBubbleHideStyle(host.shadowRoot);
    observeShadow(host.shadowRoot);
    host.setAttribute('data-tm-bubble-hidden', 'true');
    disconnectHostObserver();
    return true;
  }

  function watchForChatHost() {
    if (hideWidgetBubble()) return;

    if (hostObserver || !document.body) return;

    hostObserver = new MutationObserver(function () {
      hideWidgetBubble();
    });

    hostObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function openLiveChat() {
    var host = getChatHost();
    if (!host || !host.shadowRoot) return false;

    hideWidgetBubble();

    var btn = host.shadowRoot.querySelector('.tm-btn');
    if (!btn) return false;

    btn.click();
    return true;
  }

  function startChatUiBridge() {
    if (bridgeStarted) return;
    bridgeStarted = true;

    watchForChatHost();

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (hideWidgetBubble() || attempts >= 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function handleChatButtonClick(evt) {
    var chatBtn = evt.target.closest('[data-tm-open-chat]');
    if (!chatBtn) return;

    evt.preventDefault();

    if (openLiveChat()) return;

    scheduleLoad();

    var retries = 0;
    var retryTimer = setInterval(function () {
      if (openLiveChat() || ++retries >= 25) {
        clearInterval(retryTimer);
      }
    }, 400);
  }

  function initContactStack() {
    document.addEventListener('click', handleChatButtonClick);
    watchForChatHost();
    startChatUiBridge();
  }

  interactionEvents.forEach(function (eventName) {
    window.addEventListener(eventName, scheduleLoad, {
      once: true,
      capture: true,
      passive: eventName === 'scroll' || eventName === 'touchstart',
    });
  });

  fallbackTimer = setTimeout(scheduleLoad, 15000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactStack);
  } else {
    initContactStack();
  }

  watchForChatHost();
})();
